/**
 * Firebase push ids (`ref.push().key`) start with 8 characters that encode the client
 * time of their creation in a modified base64 alphabet (sorted by ASCII, so the ids
 * sort chronologically). Decoding them gives the age of a poll without a database read -
 * used in the header write diagnostics
 * (workorder-persist-new-poll-single-flight-2026-09-22, task 5).
 */
const PUSH_ID_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
const PUSH_ID_TIME_CHARS = 8;

/** creation time (epoch ms) encoded in a push id; null for anything that is not a push id */
export function pushIdTimestamp(pushId: string | null | undefined): number | null {
    if (typeof pushId !== 'string' || pushId.length < PUSH_ID_TIME_CHARS) return null;
    let time = 0;
    for (let i = 0; i < PUSH_ID_TIME_CHARS; i++) {
        const index = PUSH_ID_CHARS.indexOf(pushId.charAt(i));
        if (index < 0) return null;
        time = time * 64 + index;
    }
    return time;
}

/** milliseconds between the creation of a push id and `now`; null for anything that is not a push id */
export function pushIdAgeMs(pushId: string | null | undefined, now: number = Date.now()): number | null {
    const created = pushIdTimestamp(pushId);
    return created === null ? null : now - created;
}
